import React, { useState } from "react";
import { Row, Col, Modal, Button } from "antd";
import { motion } from "framer-motion";
import "./logodesgin.css";

import logo1 from "../Asset/About/logo1.png";
import logo2 from "../Asset/About/logo2.png";
import logo3 from "../Asset/About/logo3.png";
// import logo4 from "../Asset/About/logo4.png";
// import logo5 from "../Asset/About/logo5.png";
import logo6 from "../Asset/About/logo6.png";
import logo7 from "../Asset/About/logo7.png";
import logo8 from "../Asset/About/logo8.jpg";
import logo9 from "../Asset/About/logo9.jpg";
import logo10 from "../Asset/About/logo10.png";
import logo11 from "../Asset/About/logo11.png";
import logo12 from "../Asset/About/logo12.png";
import logo13 from "../Asset/About/logo13.png";
import logo14 from "../Asset/About/logo14.jpg";
import logo15 from "../Asset/About/logo15.jpg";

const photos = [
  logo1, logo2, logo3, logo6,
  logo7, logo8, logo9, logo10, logo11, logo12,logo13,logo14,logo15
];

const LogoDesgin = () => {
  const [selectedPhoto, setSelectedPhoto] = useState(null);

  return (
    <div className="logo-container">

      {/* Animated Wave Layers */}
      <div className="wave wave1"></div>
      <div className="wave wave2"></div>
      <div className="wave wave3"></div>

      <h1 className="page-title">Logo Design</h1>

      <Row gutter={[16, 16]} justify="center">
        {photos.map((photo, index) => (
          <Col key={index} xs={24} sm={12} md={8} lg={6}>
            <motion.div
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => setSelectedPhoto(photo)}
              className="logo-card"
            >
              <img src={photo} alt={`Logo ${index + 1}`} className="logo-image" />
            </motion.div>
          </Col>
        ))}
      </Row>

      <Modal
        open={selectedPhoto !== null}
        onCancel={() => setSelectedPhoto(null)}
        footer={null}
        centered
        width={800}
      >
        <img src={selectedPhoto} alt="Selected" className="modal-image" />
        <Button type="primary" onClick={() => setSelectedPhoto(null)} block>
          Close
        </Button>
      </Modal>
    </div>
  );
};

export default LogoDesgin;
